// eslint-disable-next-line camelcase
export const es_ES = {
	commons: {
		title: 'Solicitud de reembolso por cancelación',
		navigation: {
			review: 'Revisar trayecto introducido',
			back: 'Volver',
			next: 'Siguiente'
		},
		sidebar: {
			navigation: 'Navegación',
			mainPageLink: 'Página de inicio',
			mainPageUrl: 'https://www.flightright.es',
			essentialLinks: {
				title: 'Enlaces importantes',
				privacyStatement: {
					linkText: 'política de privacidad y cookies',
					url: 'https://www.flightright.es/privacidad'
				},
				termsAndConditions: {
					linkText: 'Términos y condiciones generales',
					url: 'https://www.flightright.es/condiciones-generales'
				},
				imprint: {
					linkText: 'Departamento legal',
					url: 'https://www.flightright.es/aviso-legal'
				}
			}
		},
		share: '¿Satisfecho? Comparta nuestro servicio de reembolso con amigos y familiares',
		shareTitle: '¿Cancelación de un vuelo por coronavirus? ¡Reclame su dinero con Flightright!',
		datePlaceholder: 'DD/MM/YYYY',
		emberCCLink: 'https://www.flightright.es/calculadora-de-indemnizacion/#/flow/airports'
	},
	cancelled: {
		heading: '¿Cómo se canceló su vuelo?',
		airline: 'La aerolínea canceló mi vuelo',
		customer: 'Cancelé mi vuelo'
	},
	refundOffer: {
		heading: '¿La aerolínea le ofreció un reembolso?',
		title: 'Un reembolso es la devolución del precio del billete, por ejemplo, mediante el pago a su  tarjeta de débito o crédito. El reembolso también puede realizarse en forma de bono o de una nueva reserva del vuelo. Sin embargo, no está obligado a aceptarlos y puede exigir un pago en efectivo.'
	},
	refundAccepted: '¿Aceptó la oferta?',
	refundReceived: '¿Ha recibido el reembolso de la aerolínea?',
	additionalData: {
		heading: 'Necesitamos la siguiente información',
		legalInsurance: '¿Dispone de algún seguro de protección legal? *',
		bookingCode: 'Número de reserva (Opcional)',
		bookingCodePlaceholder: 'ABCDEF'
	},
	flights: {
		heading: 'Infórmenos sobre la cancelación de su vuelo',
		pluralHeading: 'Infórmenos sobre sus vuelos cancelados',
		title: 'Vuelo',
		returnTitle: 'Añadir el trayecto pendiente',
		depAirport: '¿Cuál era su aeropuerto de origen?',
		depAirportPlaceholder: 'Aeropuerto de salida',
		arrAirport: '¿Cuál era su aeropuerto de destino?',
		arrAirportPlaceholder: 'Aeropuerto de llegada',
		airline: '¿Con qué aerolínea tenía programado volar?',
		airlinePlaceholder: 'Aerolínea',
		date:	'¿Cuál era su fecha de salida programada?',
		datePlaceholder:	'DD/MM/YYYY',
		timePlaceholder:	'00:00',
		departureTime: 'Hora de salida',
		add:	'Añadir un vuelo',
		delete: 'Eliminar este vuelo',
		additionalFlight: '¿Tenía un vuelo de conexión?',
		returnFlights: '¿Tenía un vuelo de vuelta?',
		notFound: 'No puedo encontrar mi vuelo',
		status: {
			label: 'Estado del vuelo',
			placeholder: 'Seleccione una de las opciones',
			taken: 'Vuelo tomado / Lo voy a tomar',
			notTaken: 'El vuelo despegó pero no lo tomé / No lo voy a tomar',
			cancelled: 'Vuelo cancelado / cambiado',
			unknown: 'No sé si el vuelo ha sido o será cancelado (si el vuelo es en un momento posterior)'
		},
		manualScreen: {
			departureTime: '¿Cuál era su hora de salida programada?',
			sameDayToggler: {
				label: '¿Se suponía que su vuelo llegaría el mismo día o al día siguiente?',
				sameDay: 'Mismo día',
				nextDay: 'Día siguiente'
			},
			arrivalTime: '¿Cuál era su hora de llegada programada?',
			manualFlightNumber: '¿Cuál era el número de vuelo?'
		}
	},
	uploadBox: {
		heading: 'Suba la confirmación de su reserva',
		title: 'La confirmación de su reserva debe contener los números de vuelo de todos los vuelos de su reserva',
		checkBoxText: 'Envíe la confirmación de la reserva más tarde'
	},
	ticketsCost: {
		heading: '¿Cuánto costó su(s) billete(s)?',
		title: 'Por favor, proporciónenos el precio total que pagó por su(s) vuelo(s) en euros.',
		ticketLabel: 'Precio del billete',
		flightDescriptionLabel: '¿Desea proporcionar algún otro detalle relevante sobre lo ocurrido?'
	},
	passengers: {
		heading: 'Necesitamos algunos datos',
		title: 'Por favor, facilítenos el nombre y la dirección de correo electrónico de la persona que pagó los billetes',
		salutation: 'Saludo',
		firstNameLabel: 'Nombre',
		firstNamePlaceholder: 'María',
		additionalFirstNamePlaceholder: 'Elena',
		lastNameLabel: 'Apellido',
		lastNamePlaceholder: 'Pérez',
		emailLabel: 'Su dirección de correo electrónico',
		emailPlaceholder: 'su@dominio.com',
		phoneLabel: 'Número de teléfono (Opcional)',
		phonePlaceholder: '123 456 789',
		gender: {
			male: 'Sr',
			female: 'Sra'
		},
		consentToStore: {
			text: 'Me gustaría recibir información por correo electrónico sobre las promociones de Flightright GmbH. Además, acepto recibir correos recordatorios para completar mis datos. Puedo revocar mi consentimiento en cualquier momento. Para obtener información sobre la protección de datos, haga clic {dataProtection}',
			dataProtection: 'aquí',
			urlLink: '@:(checkOut.info.privacyLink.url)',
			label: 'Acepto'
		},
		address: {
			streetLabel: 'Calle',
			streetPlaceholder: 'Mayor 1',
			postalCodeLabel: 'Código postal',
			postalCodePlaceholder: '12345',
			cityLabel: 'Ciudad',
			cityPlaceholder: 'Madrid',
			countryLabel: 'País',
			countryPlaceholder: 'España'
		}
	},
	checkOut: {
		heading: '¡Buenas noticias!',
		title: 'Podría recibir una total de:',
		noWinText: 'Gratis si se reembolsa dentro de los 7 días. De no resolverse en ese plazo, será aplicará una comisión del 14% al 28% (más IVA). En caso de no tener éxito, no sería aplicable la comisión.',
		info: {
			textBeforeTermsLink: 'Al hacer clic en el botón "Reclame su dinero ahora", usted acepta nuestros ',
			termsLink: {
				linkText: 'términos y condiciones',
				url: 'https://www.flightright.es/condiciones-generales'
			},
			textBetweenLinks: 'la ',
			privacyLink: {
				linkText: 'política de privacidad',
				url: 'https://www.flightright.es/privacidad'
			},
			textAfterPrivacyLink: ' y la política de cancelación. Si la aerolínea no paga en 7 días, nuestra relación con la aerolínea será vinculable legalmente. Si el reembolso del billete se hace efectivo posteriormente, se aplicará una comisión de éxito del 14% (más IVA). En caso de que sea necesario la intervención de nuestros abogados, se aplicará una comisión adicional del 14% (más IVA).'
		},
		btnText: 'Reclamar ahora (pago necesario solo en caso de éxito)'
	},
	signature: {
		heading: 'Permítanos representarle',
		title: 'Para asegurar su reclamación, es necesario que firme el apoderamiento y así podremos representar sus intereses',
		checkBoxText: 'Prefiero firmar más tarde',
		bottomText: 'Puede encontrar el documento de cesión en nuestro correo electrónico de confirmación. Simplemente imprímalo, fírmelo y envíenoslo cuanto antes'
	},
	summary: {
		heading: '¡Hemos creado su caso!',
		title: 'Gracias por contratar a Flightright.',
		text: 'En breve recibirá un correo electrónico de confirmación con el número de su caso. Le mantendremos informado acerca de su reclamación.',
		compensation: 'Atención: Es posible que pueda recibir una compensación por este y otros vuelos antiguos hasta 5 años después. Compruebe su vuelo en nuestra calculadora de compensación',
		claimIdText: 'Su número de caso es ',
		newsletter: 'Suscríbete a nuestro boletín',
		newsletterDescription: 'Me gustaría recibir información por correo electrónico sobre las promociones de Flightright GmbH. Puedo revocar mi consentimiento en cualquier momento.',
		successSignUpTitle: 'Ya casi está...',
		successSignUpText: 'Ahora sólo tienes que hacer clic en el enlace del correo electrónico que te acabamos de enviar. Entonces la inscripción está completa.',
		primaryBtnText: 'A la calculadora de compensación',
		secondaryBtnText: 'Solicitar más reembolsos de billetes',
		tertiaryBtnText: 'Suscribir'
	},
	notify: {
		heading: '¡Estamos trabajando en este asunto!',
		title: '¡Buenas noticias, puede optar a un reembolso!',
		text1: 'Si canceló por su cuenta el vuelo, lamentablemente no es posible el reembolso total del precio del billete. Sin embargo, puede solicitar a la aerolínea el reembolso de los impuestos y tasas incluidos en el precio del billete. Estamos trabajando en un servicio para ayudarle a reclamar estos impuestos y tasas.',
		text2: 'Puede dejarnos su dirección de correo electrónico haciendo clic en el enlace de abajo y le notificaremos tan pronto como el servicio esté disponible:',
		btnText: 'Recibir notificación',
		btnHref: 'https://www.flightright.es/tax-and-fee'
	},
	noClaim: {
		heading: '¡Lo sentimos! :(',
		title: 'Ya ha recibido su reembolso, por lo que no tiene derecho a reclamar otro.',
		text: 'Atención: puede tener derecho a una compensación por este vuelo así como por los anteriores (¡hasta 5 años atrás!). Compruebe su vuelo en nuestra calculadora de compensación',
		primaryBtnText: 'Ir a la calculadora de compensación',
		secondaryBtnText: 'Compruebe otro vuelo'
	},
	notFound: {
		heading: '@:(noClaim.heading)',
		title: 'Error: Página no encontrada'
	},
	signaturePad: {
		linkText: 'Ver el documento',
		placeholder1: 'Haga clic y firme',
		placeholder2: 'tal y como aparece en su documento de identidad/pasaporte',
		retry: 'Deshacer',
		use: 'Confirmar'
	},
	toggles: {
		refundOffered: {
			yes: 'Sí, me ofrecieron un reembolso',
			no: 'No, no me ofrecieron un reembolso'
		},
		refundAccepted: {
			yes: 'Sí, acepté el reembolso',
			no: 'No, no acepté el reembolso'
		},
		refundReceived: {
			yes: 'Sí, he recibido mi reembolso',
			no: 'No, no he recibido mi reembolso'
		},
		insurance: {
			yes: 'Si, tengo un seguro protección legal',
			no: 'No, no tengo un seguro de protección legal '
		},
		dayPeriods: {
			morning: 'Mañana (0:00-11:59)',
			afternoon: 'Tarde (12:00-17:59)',
			evening: 'Noche (18:00-23:59)'
		},
		connectionFlight: {
			yes: 'Sí',
			no: 'No, fue un vuelo directo'
		},
		returnFlight: {
			yes: 'Mi reserva era ida y vuelta',
			no: 'Un solo trayecto'
		}
	},
	tooltips: {
		clearAll: 'Borrar todo',
		removeUploaded: 'Eliminar los archivos subidos',
		uploadYourFiles: 'Suba sus archivos',
		pickFiles: 'Seleccione los archivos',
		uploadFiles: 'Subir archivos',
		abortUpload: 'Cancelar'
	},
	infoBox: {
		returnFlightText: 'No importa si su vuelo del trayecto pendiente fue cancelado o no, aún necesitamos tener información sobre los dos trayectos.',
		connectionFlightText: '¿Tenía un vuelo de regreso? Por favor, haga clic en "Tenía un vuelo de regreso" e introduzca los detalles de su vuelo de vuelta en la siguiente página. ¿El viaje a su destino final incluía varios vuelos? Entonces haga clic en "Sí.'
	},
	errors: {
		fields: {
			required: 'Este campo es obligatorio',
			noResult: 'Sin resultados',
			postalCode: 'Por favor, introduzca un código postal válido',
			phoneNumber: 'Por favor, introduzca un número de teléfono válido',
			email: 'Por favor, introduzca una dirección de correo electrónico válida',
			properCityNeeded: 'Por favor, proporcione el nombre correcto de la ciudad',
			properNameNeeded: 'Por favor, proporcione un nombre correcto',
			receivedAmount: {
				equalsZero: 'El valor debe ser superior a 0',
				startsFromZero: 'El valor no debe empezar por 0'
			},
			airportMissmatch: 'Los aeropuertos no coinciden',
			date: {
				invalid: 'Formato de fecha inválido',
				missmatch: 'La fecha de vuelo no es válida. Por favor, compruebe la fecha del vuelo anterior.'
			},
			timeIsInvalid: 'Formato de hora inválido',
			outOfChronology: 'Información de hora inválida, compruebe la hora de salida y de llegada.',
			timeRangeIsTooLow: 'Tiempo de vuelo demasiado corto, compruebe la hora de salida y de llegada.',
			timeRangeIsTooBig: 'Tiempo de vuelo demasiado largo, compruebe la hora de salida y de llegada.'
		},
		boxes: {
			signatureTooSmall: 'Por favor, proporcione una firma más grande. La firma debe coincidir con la del pasaporte o el documento de identidad.',
			noFlightsFound: {
				text: 'Este vuelo no aparece en nuestro sistema. Por favor, compruebe que la información es correcta o introduzca los ',
				linkText: 'datos de vuelo manualmente'
			},
			noCancelledFlightYet: {
				text: 'Su vuelo no parece ser válido. Por favor, compruebe su ',
				linkText: 'itinerario de vuelo.'
			},
			newsletter: 'Error de suscripción: no se puede suscribir al cliente para recibir un boletín',
			routeDataNotSet: 'Lo sentimos. Hubo un error al enviar esta información. Por favor, inténtelo de nuevo.',
			routeDataNotUpdated: 'Lo sentimos. Se ha producido un error al actualizar esta información. Por favor, inténtelo de nuevo.',
			ticketPriceNotSet: 'Lo sentimos. Se ha producido un error al guardar el precio de la entrada. Por favor, inténtelo de nuevo.',
			caseNotCreated: 'Lo sentimos. Se ha producido un error al procesar su información. Por favor, regrese un paso y vuelva a intentarlo.',
			customerDataNotSet: 'Lo sentimos. Se ha producido un error al guardar su información. Por favor, inténtelo de nuevo.',
			flightsNotSet: 'Lo sentimos. Se ha producido un error al guardar la información de su vuelo. Inténtelo de nuevo.',
			flightsNotFetched: 'Lo sentimos. Hubo un error al encontrar los vuelos para esta ruta. Por favor, regrese un paso y vuelva a intentarlo.'
		}
	},
	partner: {
		logosBlock: {
			title: 'Viaja con tranquilidad',
			description: 'Allyz puede ayudarte antes, durante y después de tu viaje'
		},
		actionBlock: {
			title: 'Por ser cliente de Flightright tienes acceso a una cuenta Allyz Premium totalmente gratis',
			list: {
				1: 'Acceso gratuito a una sala VIP del aeropuerto en caso de retraso de más de una hora de tu vuelo',
				2: 'Alertas sanitarias relacionadas con Covid-19 por email',
				3: 'Teleconsulta: acceso a un médico por video o teléfono las 24 horas del día'
			},
			btnLabel: 'Regístrate ahora para acceder a todos los beneficios de Az+',
			btnUrl: 'https://es.allyz.com/Partners/Flightright?ac=Flightright&affId=Flightright&tduid=Flightright&utm_source=Flightright_landingpage'
		}
	}
}
